import { BToast } from 'bootstrap-vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'
import util from '@/util'
import mensagens from '@/util/mensagens'
import mascaras from '@/util/mascaras'
import cnpj from '@/util/cnpj'
import cnpjMask from '@/util/cnpjMask'
import cookieUtil from '@/util/cookieUtil'
import constants from '@/util/constants'
import { validarCampos } from '@/util/validacaoUtil'
import TelefoneInput from '@/components/layout/telefone/TelefoneInput'
import { mapActions, mapGetters } from 'vuex'
import { sanitizar } from '@/util/sanitizacao'

export default {
  name: 'SignUp',
  components: {
    spinnerProcessando,
    'b-toast': BToast,
    PainelAcesso,
    TelefoneInput
  },
  computed: {
    mascaraDocumento () {
      if (this.dadosFormulario.tipo === constants.tipoEntidadePessoa.fisica) {
        return mascaras.mascarasParaCampos.cpf
      }

      return cnpjMask.obterMascaraCnpj(this.dadosFormulario.cpf_cnpj)
    },
    ehPessoaFisica () {
      return this.dadosFormulario.tipo === constants.tipoEntidadePessoa.fisica
    },
    ehPessoaJuridica () {
      return this.dadosFormulario.tipo === constants.tipoEntidadePessoa.juridica
    },
    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    }
  },
  data () {
    return {
      dadosFormulario: {
        nome: '',
        email: '',
        cpf_cnpj: '',
        tipo: constants.tipoEntidadePessoa.fisica,
        razao_social: '',
        numero_telefone: '',
        bairro: '',
        cep: '',
        cidade: '',
        complemento: '',
        endereco: '',
        numero: '',
        uf: ''
      },
      erroValidacaoCampos: {},
      flags: this.obterFlagsDefault(),
      dataSelect: {
        tipo: [{ tipo: constants.tipoEntidadePessoa.fisica, label: 'Pessoa Fisica' }, { tipo: constants.tipoEntidadePessoa.juridica, label: 'Pessoa Juridica' }]
      },
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        },

        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },

  mounted () {
    this.ActionSetDadosCampanhaMarketing([])
  },

  methods: {
    ...mapActions('auth', ['ActionSetDadosCampanhaMarketing']),
    ...mapGetters('auth', ['dadosCampanhaMarketing']),
    obterFlagsDefault () {
      return {
        exibirSignupRegistro: true,
        exibirSignupRegistroSucesso: false,
        erro: false
      }
    },
    eventoAlterarTipoPessoa () {
      this.limparCampos()
      this.resetarFlags()
      this.resetarMensagensErros()
    },
    mascaraFone (valor) {
      return mascaras.mascaraTelefoneCelular(valor)
    },
    limparCampos () {
      this.dadosFormulario.nome = ''
      this.dadosFormulario.email = ''
      this.dadosFormulario.cpf_cnpj = ''
      this.dadosFormulario.razao_social = ''
      this.dadosFormulario.numero_telefone = ''
      this.dadosFormulario.bairro = ''
      this.dadosFormulario.cep = ''
      this.dadosFormulario.cidade = ''
      this.dadosFormulario.complemento = ''
      this.dadosFormulario.endereco = ''
      this.dadosFormulario.numero = ''
      this.dadosFormulario.uf = ''
    },
    resetarMensagensErros () {
      this.erroValidacaoCampos = {}
    },
    resetarFlags () {
      this.flags = { ...this.obterFlagsDefault() }
    },
    validarCampos () {
      this.resetarFlags()

      const campos = [
        {
          campo: 'email',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => valor.length > 0 },
            { mensagem: 'Insira um endereço de e-mail válido.', validar: valor => util.validarEmail(valor) }
          ]
        },
        {
          campo: 'nome',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => valor.length > 0 }
          ]
        },
        {
          campo: 'cpf_cnpj',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => valor.length > 0 }
          ]
        },
        {
          campo: 'numero_telefone',
          validacoes: [
            { mensagem: 'Esse campo é obrigatório.', validar: valor => valor.length > 0 },
            {
              mensagem: 'O telefone deve ter entre 10 e 11 dígitos, incluindo o DDD.',
              validar: valor => {
                const apenasNumeros = valor.replace(/\D/g, '')
                return apenasNumeros.length >= 10 && apenasNumeros.length <= 11
              }
            }
          ]
        }
      ]

      const validacao = validarCampos(campos, this.dadosFormulario)
      this.erroValidacaoCampos = { ...validacao.listaDeErros }
      const dadosValidos = !validacao.erro
      return dadosValidos
    },

    async registrar () {
      let dadosRespostaRequisicao = null

      const dadosValidos = this.validarCampos()
      if (!dadosValidos) {
        return
      }

      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const dadosCampanha = this.obterInformacoesPromocionais(this.$route.query)
        this.ActionSetDadosCampanhaMarketing(dadosCampanha)
        await cookieUtil.gerarCookieTokenCsrf()
        const payload = {
          ...util.mapearObjetos(this.dadosFormulario, {}),
          dados_campanha: this.dadosCampanhaMarketing()
        }
        const resposta = await this.axios.post('/manager/signup', payload,
          {
            withCredentials: true
          })

        dadosRespostaRequisicao = resposta.data

        // Com erro
        if (!dadosRespostaRequisicao.retorno.sucesso) {
          this.apresentarErrosValidacaoCampos(dadosRespostaRequisicao)
        }

        // Sucesso
        if (dadosRespostaRequisicao.retorno.sucesso) {
          this.flags.exibirSignupRegistro = false
          this.flags.exibirSignupRegistroSucesso = true
        }
      } catch (e) {
        if (e.response.status === 400) {
          util.criarAlertaToastDeErro(this, 'Aviso', e.response.data.retorno.mensagem)
          this.apresentarErrosValidacaoCampos(e.response.data)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        }
      } finally {
        this.definirFlagManipulandoDados(false, '')
      }

      return dadosRespostaRequisicao
    },

    async buscarInformacoesDoCnpj () {
      const cnpjNormalizado = cnpj.normalizarCnpj(this.dadosFormulario.cpf_cnpj)

      if (!cnpjNormalizado || cnpjNormalizado.length < 14) {
        return
      }

      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/consultar/cnpj/${cnpjNormalizado}`)
        if (resposta.data.retorno.sucesso) {
          this.dadosFormulario.nome = resposta.data.retorno.dados.fantasia || resposta.data.retorno.dados.nome
          this.dadosFormulario.razao_social = resposta.data.retorno.dados.nome || this.dadosFormulario.razao_social
          this.dadosFormulario.numero_telefone = resposta.data.retorno.dados.telefone || this.dadosFormulario.numero_telefone
          this.dadosFormulario.email = resposta.data.retorno.dados.email || this.dadosFormulario.email

          this.dadosFormulario.cep = resposta.data.retorno.dados.cep
          this.dadosFormulario.endereco = resposta.data.retorno.dados.logradouro
          this.dadosFormulario.bairro = resposta.data.retorno.dados.bairro
          this.dadosFormulario.cidade = resposta.data.retorno.dados.municipio
          this.dadosFormulario.numero = resposta.data.retorno.dados.numero
          this.dadosFormulario.complemento = resposta.data.retorno.dados.complemento
          this.dadosFormulario.uf = resposta.data.retorno.dados.uf

          util.criarAlertaToastDeSucesso(this, 'Aviso', resposta.data.retorno.mensagem)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', resposta.data.retorno.mensagem)
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCancelandoContrato)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    apresentarErrosValidacaoCampos (dadosRespostaRequisicao) {
      if (dadosRespostaRequisicao.retorno.listaDeErros.length === 0) {
        util.criarAlertaToastDeErro(this, 'Aviso', dadosRespostaRequisicao.retorno.mensagem)
      }

      this.erroValidacaoCampos = dadosRespostaRequisicao.retorno.listaDeErros
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    obterInformacoesPromocionais (query) {
      const informacoesPromocionais = Object.keys(query)
        .reduce((obj, key) => {
          obj[key] = sanitizar(query[key])
          return obj
        }, {})
      return informacoesPromocionais
    }
  }
}
